/**
 * Created by Jonas Wålekvist on 2018-04-26.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap"
import {DungeonQuestLayerConfig} from "../../../config/DungeonQuestLayerConfig";
import {DungeonQuestParticleConfig} from "../../../config/DungeonQuestParticleConfig";
import {MaskCreator} from "../../../utils/MaskCreator";
import {ShakeUtil} from "../../../utils/ShakeUtil";
import {ShakeEffect} from "../../display/effects/ShakeEffect";
import {TweenParticleEmitter} from "../../display/TweenParticleEmitter";
import {DungeonQuestGameAssets} from "../../DungeonQuestGameAssets";
import {DungeonQuestGameConfig} from "../../DungeonQuestGameConfig";
import {DungeonQuestSound} from "../../DungeonQuestSound";

export class DungeonQuestRandomColossalWildIntroView extends BaseView {

    private _introContainer:PIXI.Container;
    private _fireOverlay:TimelineSprite;
    private _comet1:TimelineSprite;
    private _comet2:TimelineSprite;
    private _introMask:PIXI.Graphics;
    private _particleLayerBottom:ScalableLayer;
    private _particleLayerTop:ScalableLayer;
    private _cometMask:PIXI.Sprite;
    private _cometContainer:PIXI.Container;

    get shakeEffect():ShakeEffect {
        if(!this._shakeEffect) {
            this._shakeEffect = ShakeUtil.createDefaultShake();
        }
        return this._shakeEffect;
    }

    private _layer:ScalableLayer;
    private _rockParticles:TweenParticleEmitter;
    private _shakeEffect:ShakeEffect;
    private _loopAnimation:TimelineLite | null;

    private _reelStopped:boolean = true;
    public get reelStopped():boolean {
        return this._reelStopped;
    }

    public set reelStopped(value:boolean) {
        this._reelStopped = value;
    }

    constructor(resourceGroup?:ResourcesGroupName) {
        super(resourceGroup);
        this._particleLayerBottom = StageManager.getLayer(DungeonQuestLayerConfig.PARTICLES_BOTTOM.name);
        this._particleLayerTop = StageManager.getLayer(DungeonQuestLayerConfig.PARTICLES_TOP.name);
        this._layer = StageManager.getLayer(DungeonQuestLayerConfig.RANDOM_FEATURE_INTRO.name);
        this._layer.addChild(this);
    }

    protected onResize(resizeData:IResizeData):void {
        this._layer.y = StageManager.getLayer(DungeonQuestLayerConfig.SYMBOLS.name).y;
        this._cometContainer.position.y = resizeData.orientation == Orientation.PORTRAIT ? 0 : 240;

    }

    protected initAnimations():void {
        this._introMask = MaskCreator.createSymbolAreaMaskGraphics(0, 600);
        this._introMask.position.y = -600;

        this._introContainer = new PIXI.Container();
        this._introContainer.addChild(this._introMask);
        this._introContainer.mask = this._introMask;
        this.createIntroGfx();


        const rockTextures:PIXI.Texture[] = [
            GameResources.getTextures(DungeonQuestGameAssets.ROCK_PARTICLE_1)[0],
            GameResources.getTextures(DungeonQuestGameAssets.ROCK_PARTICLE_2)[0],
            GameResources.getTextures(DungeonQuestGameAssets.ROCK_PARTICLE_3)[0]
        ];

        this._rockParticles = new TweenParticleEmitter(rockTextures, DungeonQuestParticleConfig.rockParticleConfig);
        this._rockParticles.position.set(0, DungeonQuestGameConfig.instance.REEL_AREA_HEIGHT + 240);

        this._particleLayerTop.addChild(this._rockParticles);
        this.addChild(this._introContainer);

    }

    private createIntroGfx() {
        this._fireOverlay = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_INTRO_FIRE));
        this._fireOverlay.anchor.set(0.026, 0.987);
        this._fireOverlay.position.set(0, DungeonQuestGameConfig.instance.REEL_AREA_HEIGHT + 240);
        this._fireOverlay.scale.set(2.85);
        this._fireOverlay.hide();

        this._comet1 = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_INTRO_COMET));
        this._comet1.rotation = 2;
        this._comet1.position.set(720, -180);
        this._comet1.anchor.set(0.1, 0.5);
        this._comet1.hide();
        this._comet1.scale.set(1.9);

        this._comet2 = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_INTRO_COMET));
        this._comet2.rotation = 1.85;
        this._comet2.position.set(720, 0);
        this._comet2.anchor.set(0.1, 0.5);
        this._comet2.hide();
        this._comet2.scale.set(1.5);

        this._cometContainer = new PIXI.Container();

        this._cometMask = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_INTRO_COMET_MASK)[0]);
        this._cometMask.anchor.set(0.5, 1);
        this._cometMask.position.set(DungeonQuestGameConfig.instance.REEL_AREA_WIDTH * 0.5, DungeonQuestGameConfig.instance.REEL_AREA_HEIGHT);


        this._cometContainer.addChild(this._cometMask);
        this._cometContainer.addChild(this._comet1);
        this._cometContainer.addChild(this._comet2);
        this._cometContainer.mask = this._cometMask;

        this._particleLayerBottom.addChild(this._cometContainer);
        this._introContainer.addChild(this._fireOverlay);
    }

    public getIntroAnimation(symbol:string):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const comets:TimelineLite = new TimelineLite();
        comets.add(this._comet2.getAnimationAutoShowHide(true, true));
        comets.add(this._comet1.getAnimationAutoShowHide(true, true), 0.5);

        tl.add(comets, 0.5);
        tl.add([
            () => SlotGame.sound.playEffect(DungeonQuestSound.RANDOM_WILD_INTRO_EXPLOSION),
            () => this._rockParticles.start(),
            this._fireOverlay.getAnimationAutoShowHide(true, true)
        ], "-=0.6");
        tl.add(() => this.startLoop(), 0.8);

        return tl;
    }

    public startLoop() {
        if(this._loopAnimation) {
            this.stopLoop();
        }
        if(!this._reelStopped) {
            this.shakeEffect.startShake();
        }
        SlotGame.sound.playEffect(DungeonQuestSound.RANDOM_WILD_RUMBLE);
    }

    public stopLoop() {
        this.shakeEffect.stopShake();
        if(this._loopAnimation) {
            this._loopAnimation.pause(0);
            this._loopAnimation.kill();
        }
        this._loopAnimation = null;
    }


}